import { h, Component } from 'preact';
import CalendarEmpty from 'components/bolt/icons/calendarEmpty';
import ComingSoon from 'components/bolt/icons/comingSoon';
import Reel from 'components/bolt/icons/reel';
import Location from 'components/bolt/icons/location';
import Button from 'components/bolt/button/button';
import HTML from 'components/core/html/html';
import VideoPlayer from 'components/bolt/videos/player';
import { joinClasses, accessNested, sortObjectByOrder } from 'utils/utils';
import { navigateInternally } from 'utils/bolt';
import { getPlaylistData } from 'services/boltYoutube';
import Store from 'store/store';


import s from 'components/bolt/showtimes/showtimesMessage.sss';

export default class ShowtimesMessage extends Component {
	constructor(props) {
		super(props);
		this.state.videos = [];
		this.triggerFunc = this.triggerFunc.bind(this);
		this.triggerExtraButton = this.triggerExtraButton.bind(this);
		this.onEndedHandler = this.onEndedHandler.bind(this);
	}

	componentDidMount() {
		const { videosLoading, showtimesVideos } = this.props;

		const videoDatalist = accessNested(Store.get(), 'appData.pages.boltShowtimes.data.noShowtimes.video', {});
		const videoDataArray = sortObjectByOrder(videoDatalist, (value, key) => {
			return {
				...value,
				key
			};
		});

		if (showtimesVideos && !showtimesVideos.length && !videosLoading) {
			Store.emit('SHOWTIMES_MESSAGE_VIDEOS_LOADING', true);
			this.replacePlaylistWithVideos(videoDataArray);
		}
	}

	getVideosFromPlaylist(vid) {
		const playlistId = vid.youtubePlaylistId;
		return getPlaylistData(playlistId).then(data => {
			return data.items.filter(item => item.snippet.thumbnails.medium).sort((a, b) => this.sortPlaylist(a, b, vid.playlistOrder)).map(item => ({
				name: item.snippet.title,
				thumbSrc: item.snippet.thumbnails.medium.url,
				youtubeId: item.snippet.resourceId.videoId,
				key: item.id
			}));
		});
	}

	replacePlaylistWithVideos(videoDataArray) {
		Promise.all(videoDataArray.map(vid => {
			if (vid.youtubePlaylistId) {
				return this.getVideosFromPlaylist(vid);
			}
			return vid;
		})).then((data) => {
			Store.emit('SHOWTIMES_MESSAGE_PLAYLIST_LOADED', [].concat(...data));
		});
	}

	sortPlaylist(a, b, order) {
		if (!order) {
			return 0;
		}
		const playlistOrder = order.replace(/\s/g, '').split(',').reverse();

		return playlistOrder.indexOf(b.snippet.resourceId.videoId) - playlistOrder.indexOf(a.snippet.resourceId.videoId);
	}

	getNextVideo(activeVideo, videos) {
		if (!activeVideo || !videos.length) {
			return;
		}

		const activeVidIndex = videos.findIndex((vid) => vid.key === activeVideo.key);
		return videos[activeVidIndex + 1];
	}

	onEndedHandler() {
		const activeVideo = this.props.activeVideo;
		const nextVideo = this.getNextVideo(activeVideo, this.props.showtimesVideos);

		if (nextVideo) {
			Store.emit('SHOWTIMES_MESSAGE_UPDATE_VIDEO', nextVideo);
		}
	}

	triggerFunc() {
		if (typeof this.props.buttonTrigger === 'function') {
			this.props.buttonTrigger();
		}
	}

	triggerExtraButton(path) {
		if (path.match(/^bolt/) || path.startsWith('@')) {
			navigateInternally(path);
			return;
		}

		let link = document.createElement('a');
		link.href = path;
		link.target = '_blank';
		link.style.display = 'none';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	renderButtons({ buttons = {} }, fontStyles, regionButtonsOverride) {
		let extraButton = regionButtonsOverride?.extraButton || buttons.extraButton;
		const { copy, noFiltersAvailable } = this.props;
		let renderFilters = this.props.buttonCopy && buttons.filtersButton && !noFiltersAvailable;
		if (regionButtonsOverride?.filtersButton !== undefined) {
			renderFilters = regionButtonsOverride.filtersButton;
		}

		return (
			<div class={s.buttons} key="buttons">
				{extraButton && (
					<Button
						type="primary"
						class={joinClasses(s.button, fontStyles.showtimesErrorButton)}
						trigger={() => this.triggerExtraButton(extraButton.path)}
						ariaLabel={this.props.buttonCopy}
						key="extraButton"
					>
						{copy.baseCopy[extraButton.label] || extraButton.label}
					</Button>
				)}
				{renderFilters && (
					<Button
						type="primary"
						class={joinClasses(s.button, fontStyles.showtimesErrorButton)}
						trigger={this.triggerFunc}
						ariaLabel={this.props.buttonCopy}
						key="filtersButton"
					>
						{this.props.buttonCopy}
					</Button>
				)}
			</div>
		);
	}

	renderVideo() {
		const activeVideo = this.props.activeVideo;

		return (
			<div class={s.videoWrapper} key="video">
				<VideoPlayer
					activeVideo={activeVideo}
					onEndedHandler={this.onEndedHandler}
					overrideStyles
					noAutoplay
					isShowtimesMessage
				/>
			</div>
		);
	}

	renderIcon(type) {
		if (type === 'reel') {
			return <Reel aria-hidden />;
		} else if (type === 'coming-soon') {
			return <ComingSoon aria-hidden />;
		} else if (type === 'location') {
			return <Location aria-hidden />;
		}
		return <CalendarEmpty aria-hidden />;
	}

	render(props) {
		const { isMap, deviceSize, noShowtimes, icon, regionButtonsOverride, isPreviewPanel } = props;

		const isMobileMap = isMap && deviceSize === 'mobile';

		const fontStyles = accessNested(Store.get(), 'appData.styling.fontVariables');

		return (
			<div class={joinClasses(s.container, props.class, isMobileMap && s.isMap, isPreviewPanel && s.previewPanel)}>
				<div class={s.topRow} key="toprow">
					{!props.noCalendar && (
						<div class={s.calendarEmpty} key="calendar">
							{this.renderIcon(icon)}
						</div>
					)}
					{noShowtimes && noShowtimes.video && this.renderVideo()}
					<HTML
						tag="span"
						class={joinClasses(s.message, fontStyles.showtimesErrorTitle)}
						content={props.message}
						markdown
						key="message"
					/>
					{props.cta && (
						<HTML
							tag="span"
							class={joinClasses(s.ctaText, fontStyles.showtimesErrorDescription)}
							content={props.cta}
							markdown
							key="description"
						/>
					)}
				</div>
				{!noShowtimes && props.buttonCopy && (
					<Button
						type="primary"
						class={joinClasses(s.button, fontStyles.showtimesErrorButton)}
						trigger={this.triggerFunc}
						ariaLabel={props.buttonCopy}
						key="button"
					>
						{props.buttonCopy}
					</Button>
				)}
				{noShowtimes && this.renderButtons(noShowtimes, fontStyles, regionButtonsOverride)}
			</div>
		);
	}
}
